// extracted by mini-css-extract-plugin
module.exports = {"header":"SalesregHeader_header__NgN1S","syncBtn":"SalesregHeader_syncBtn__25sOs","rightSection":"SalesregHeader_rightSection__2MV38"};